:host {
  position: fixed;
  height: 500px;
  width: 100%;
  min-width: 360px;
  flex-direction: column;
  font-family: 'Barlow', sans-serif;
  font-size: 13px;
  z-index: 9999;
  width: fit-content;
  height: fit-content;

  .addi-modal {
    position: fixed;
    display: flex;
    flex-direction: column;
    height: fit-content;
    padding: 24px 0;
    width: 430px;
    min-height: 600px;
    border-radius: 20px;
    opacity: 1;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    -webkit-box-shadow: 2px 1px 8px 0px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 2px 1px 8px 0px rgba(0, 0, 0, 0.2);
    box-shadow: 2px 1px 8px 0px rgba(0, 0, 0, 0.2);

    &_overlay {
      position: fixed !important;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 1;
      cursor: pointer;
      display: inherit;

      &--open {
        display: block;
      }

      &--closed {
        display: none;
      }
    }

    &_iframe {
      border: none;
      width: 100%;
      height: 570px;
      overflow: hidden;
    }

    &_header {
      width: 100%;
      height: fit-content;
      display: flex;
      flex-direction: row-reverse;
      box-sizing: border-box;
      padding-right: 22px;

      button {
        background-color: #ffffff !important;
        border-radius: 50% !important;
        border: none;
        cursor: pointer;
        padding: 0;
        height: 24px;
        display: contents;
      }
    }
  }

  .addi-close-button {
    width: 24px;
    height: 24px;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }

  .addi-loading {
    background: url('https://statics.addi.com/widget/addi-loader.svg') center
      center no-repeat;
    background-size: 100px;
  }
}

@media (max-width: 480px) {
  :host {
    .addi-modal {
      width: 100vw;
      height: 100vh;
      padding: 16px;
      border-radius: 0;

      &_iframe {
        height: 100vh;
      }

      &_header {
        padding-right: 0;
      }

      &_header button {
        margin-right: 0;
      }
    }
  }
}
